<script lang="ts" module>
	import type { ISbRichtext, ISbStoryData, SbBlokData } from '@storyblok/js';

	export interface PdpSubnavItem extends SbBlokData {
		title: string;
		description: ISbRichtext;
		anchor?: string;
	}
</script>

<script lang="ts">
	import { editable } from '$lib/storyblok/editable';
	import SbRichtext from '$lib/storyblok/components/sbRichtext.svelte';
	import ChevronDown from '$lib/icons/chevronDown.svelte';
	import { slide } from 'svelte/transition';

	interface Props {
		content: ISbStoryData<PdpSubnavItem>['content'];
		active?: boolean;
		onopen?: () => void;
		onclose?: () => void;
	}

	let { content, active = false, onopen, onclose }: Props = $props();
</script>

<article use:editable={content} class="border-b border-brown-5 py-4 last:border-b-0">
	<!-- svelte-ignore a11y_click_events_have_key_events -->
	<div
		tabindex="0"
		role="button"
		class="flex justify-between gap-x-0.5"
		onclick={active ? onclose : onopen}
	>
		<h1 class="mb-1 text-[18px] tracking-[-.18px]">{content.title}</h1>
		<ChevronDown class={['h-6 w-6', { 'rotate-180': active }]} />
	</div>

	{#if active}
		<div class="text-[14px]/[160%]" transition:slide>
			<div class="text-brown-4">
				<SbRichtext text={content.description} />
			</div>

			{#if content.anchor && content.anchor.length > 0}
				<a class="mt-1 block text-green-2" href="#{content.anchor}">Learn more →</a>
			{/if}
		</div>
	{/if}
</article>
